var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookIconNoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.2 28.7",
    style: {
      enableBackground: "new 0 0 27.2 28.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_17",
    transform: "translate(-1698.918 -260.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_279",
    className: "st0",
    d: "M1715.4,271.4h5.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-5.6c-0.3,0-0.5,0.2-0.5,0.5 S1715.2,271.4,1715.4,271.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_280",
    className: "st0",
    d: "M1715.4,269.1h5.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-5.6c-0.3,0-0.5,0.2-0.5,0.5 S1715.2,269.1,1715.4,269.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    className: "st0",
    d: "M1715.4,266.8h5.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-5.6c-0.3,0-0.5,0.2-0.5,0.5 S1715.2,266.8,1715.4,266.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    className: "st0",
    d: "M1715.4,264.5h5.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-5.6c-0.3,0-0.5,0.2-0.5,0.5 S1715.2,264.5,1715.4,264.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    className: "st0",
    d: "M1709.3,270.4h-5.6c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h5.6c0.3,0,0.5-0.2,0.5-0.5 S1709.6,270.4,1709.3,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_284",
    className: "st0",
    d: "M1703.7,269.1h5.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-5.6c-0.3,0-0.5,0.2-0.5,0.5 S1703.4,269.1,1703.7,269.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_285",
    className: "st0",
    d: "M1703.7,266.8h5.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-5.6c-0.3,0-0.5,0.2-0.5,0.5 S1703.4,266.8,1703.7,266.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_286",
    className: "st0",
    d: "M1703.7,264.5h5.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-5.6c-0.3,0-0.5,0.2-0.5,0.5 S1703.4,264.5,1703.7,264.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_287",
    className: "st0",
    d: "M1725.1,283.2l-1.7-1.7c-1.1-1.1-2.9-1.3-4.2-0.4l-0.9-0.9c-0.9-0.9-2.3-0.9-3.3-0.1 c-0.4,0.4-0.7,1-0.7,1.7c0,1.7-1.3,3.2-3.1,3.4c-0.7,0.1-1.4,0.1-2.1,0c-2.1-0.1-3.7-1.8-3.6-3.8v-3.7h4.5v0.4 c0,0.7,0.5,1.2,1.2,1.2h2c0.7,0,1.2-0.5,1.2-1.2v-0.4h10.8c0.3,0,0.5-0.2,0.5-0.5v-13.6c0-0.3-0.2-0.5-0.5-0.5h-1.5v-2.3 c0-0.3-0.2-0.5-0.5-0.5h-8.3c-0.9,1.4-2.9,1.8-4.3,0.9c-0.4-0.2-0.7-0.5-0.9-0.9h-8.3c-0.3,0-0.5,0.2-0.5,0.5v2.3h-1.5 c-0.3,0-0.5,0.2-0.5,0.5v13.6c0,0.3,0.2,0.5,0.5,0.5h5.2v3.7c0,2.6,2,4.7,4.6,4.8c0.2,0,0.5,0,0.7,0c0.5,0,1,0,1.5-0.1 c2.2-0.2,4-2.1,4-4.4c0-0.7,0.6-1.3,1.3-1.3c0.4,0,0.7,0.1,0.9,0.4l0.9,0.9c-1.1,1.3-1,3.2,0.2,4.4l1.7,1.7c1.3,1.3,3.4,1.3,4.7,0 S1726.4,284.4,1725.1,283.2L1725.1,283.2z M1715,261.1h7.8v13.1h-7.8c-0.8,0-1.5,0.3-2.1,0.7v-11.7 C1712.9,262.1,1713.8,261.2,1715,261.1C1715,261.1,1715,261.1,1715,261.1z M1701.9,261.1h7.8c1.2,0,2.1,0.9,2.1,2.1c0,0,0,0,0,0 V275c-0.6-0.5-1.4-0.7-2.1-0.7h-7.8L1701.9,261.1z M1699.9,264h1v10.8c0,0.3,0.2,0.5,0.5,0.5h8.3c0.9,0,1.7,0.5,2.2,1.3 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1l0,0l0,0c0.1,0,0.2,0,0.3,0l0,0l0,0c0,0,0.1,0,0.1-0.1 l0,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.5-0.8,1.3-1.3,2.2-1.3h8.3c0.3,0,0.5-0.2,0.5-0.5V264h1v12.6h-10.3 c-0.1-0.3-0.4-0.4-0.6-0.3c-0.2,0.1-0.3,0.3-0.3,0.5v1.2c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2v-1.2 c0-0.3-0.2-0.5-0.5-0.5c-0.2,0-0.4,0.1-0.5,0.3h-10.2L1699.9,264z M1719.5,282.2c0.9-0.9,2.4-0.9,3.3,0c0,0,0,0,0,0l0.1,0.1 l-1.2,1.2l-0.9-0.9c-0.2-0.2-0.5-0.1-0.7,0.1c-0.1,0.2-0.1,0.4,0,0.6l0.9,0.9l-1.3,1.3l-0.1-0.1 C1718.6,284.5,1718.6,283.1,1719.5,282.2L1719.5,282.2z M1724.4,287.1c-0.9,0.9-2.4,0.9-3.3,0l-0.9-0.9l3.3-3.3l0.9,0.9 C1725.3,284.8,1725.3,286.2,1724.4,287.1L1724.4,287.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIconNoColor);
export default __webpack_public_path__ + "static/media/bookIconNoColor.f57d68a5.svg";
export { ForwardRef as ReactComponent };